import React from "react";
// reactstrap components
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import "./BasicPagination.css"

const Paginations = ({
  itemsPerPage,
  totalItems,
  setCurrentPage,
  currentPage,
}) => {
  let pageNumbers = [];
  const pageLimit = 10; //máximo de ícones de páginas mostrados para ilustrar paginação
  let hidePoints = true 

  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }
  if(pageNumbers.length > pageLimit){
    pageNumbers = pageNumbers.slice(0, pageLimit)
    hidePoints = false
  }

  const paginate = (pageNumber, e) => {
    e.preventDefault();

    if (pageNumber > 0 && pageNumber <= pageNumbers.length)
      setCurrentPage(pageNumber);
  };

  return (
    <>
      <nav aria-label="Page navigation example">
        <Pagination
          className="pagination justify-content-end"
          listClassName="justify-content-end"
        >
          <PaginationItem>
            <PaginationLink
              href="#"
              onClick={(e) => paginate(currentPage - 1, e)}
              tabIndex="-1"
            >
              <i className="fa fa-angle-left" />
              <span className="sr-only">Previous</span>
            </PaginationLink>
          </PaginationItem>

          {pageNumbers.map((number) => (
            <PaginationItem key={number} className={`${currentPage === number ? "active" : ""}`} >
              <PaginationLink
                onClick={(e) => paginate(number, e)}
                href="!#"
              >
                {number}
              </PaginationLink>
            </PaginationItem>
          ))}

          {function () {
            if (hidePoints)
              return ''
            else
              return (
                <PaginationItem className="disabled">
                  <PaginationLink
                    href="#"
                  >
                    ...
                  </PaginationLink>
                </PaginationItem>
              )
          }()
          }

          <PaginationItem>
            <PaginationLink href="#" onClick={(e) => paginate(currentPage + 1, e)}>
              <i className="fa fa-angle-right" />
              <span className="sr-only">Next</span>
            </PaginationLink>
          </PaginationItem>
        </Pagination>
      </nav>
    </>
  );
}


export default Paginations;